import { Radio, Modal, Form, Input, Select } from 'antd'
import React, { useEffect, useState } from 'react'
import service from '../../../../@services'
import { plusMumber } from '../../../../@utils/index'
import ProductTable from './ProductTable'
import { connect } from 'react-redux'
const { TextArea } = Input
const PopupDetail = props => {
  const [form] = Form.useForm()
  const { hide, visible, onClose, detail = {} } = props
  const [loading, setLoading] = useState(false)
  const [orderDetail, setOrderDetail] = useState({})
  const [selectedIds, setSelectedIds] = useState([])
  const [orderStep, setOrderStep] = useState(1)
  const [allMoney, setAllMoney] = useState(0)
  const [typeList, setType] = useState([])
  const [reasonList, setReason] = useState([])
  const [dataList, setDataList] = useState([])
  useEffect(() => {
    // 售后类型
    service.order.getDropDownList('aftersaleType').then(res => {
      setType(res || [])
    })
    // 退货原因
    service.order.getDropDownList('aftersaleReason').then(res => {
      setReason(res || [])
    })
    setLoading(true)
    if (visible && detail.orderNo) {
      service.order
        .afterSaleDetailById(detail.orderNo)
        .then(data => {
          setOrderDetail(data || {})
          setLoading(false)
          data && data.orderStatus === 'finish' && setOrderStep(2)
        })
        .catch(e => {
          setLoading(false)
        })
    } else {
      setLoading(false)
      setOrderDetail({})
      setOrderStep(0)
    }
  }, [visible, detail])

  const getMoney = (ids, data = []) => {
    data.map(item => {
      item.orderDetailId = item.id
      item.refundCount = item.count
    })
    setDataList(data)
    let newMoney = 0
    data.forEach(item => {
      newMoney = plusMumber(newMoney, item.saleAmount)
    })
    setSelectedIds(ids)
    // 如果全选商品行退款金额需要加上运费
    if (data && data.length === orderDetail.orderDetails.length) {
      newMoney = plusMumber(newMoney, orderDetail.freightAmount)
    }
    setAllMoney(newMoney)
    form.setFieldsValue({ allMoney: newMoney })
  }

  const handleOk = async () => {
    setLoading(true)
    try {
      await form.validateFields()
      const params = {
        orderNo: orderDetail.orderNo,
        aftersaleBasicDetailList: dataList,
        aftersaleChan: 4,
        ...form.getFieldsValue()
      }
      const data = await service.order.createAfterSale(params)
      if (data) {
        hide()
        form.resetFields()
        setAllMoney(0)
        form.setFieldsValue({ allMoney: '0' })
        setLoading(false)
        props.showList()
      }
    } catch (error) {
      setLoading(false)
    }
  }

  const Close = () => {
    hide()
    form.setFieldsValue({ allMoney: '0' })
    form.resetFields()
    setAllMoney(0)
  }

  return (
    <Modal
      title='发起售后'
      centered
      visible={visible}
      onCancel={Close}
      onOk={handleOk}
      confirmLoading={loading}
      width={1000}
      className='order-detail-popup'>
      <Form
        labelCol={{ span: 2 }}
        wrapperCol={{ span: 22 }}
        form={form}
        initialValues={{ radiogroup: 1 }}>
        <Form.Item
          label='选择商品'
          name='allMoney'
          rules={[{ required: true, message: '请选择商品' }]}>
          <ProductTable
            data={orderDetail.orderDetails || []}
            canCheck={true}
            onChange={getMoney}
            isAfterSale={true}
          />
        </Form.Item>
        <Form.Item label='配送费' name='allMoney'>
          <a>{orderDetail.freightAmount}元</a>
        </Form.Item>
        <Form.Item
          label='退款金额'
          name='allMoney'
          rules={[{ required: true, message: '请选择商品' }]}>
          <a>{allMoney + '元'}</a>
        </Form.Item>
        <Form.Item
          label='售后类型'
          name='aftersaleType'
          rules={[{ required: true }]}>
          <Radio.Group>
            {typeList &&
              typeList.map((item, index) => (
                <Radio value={item.code} key={item.code + index}>
                  {item.name}
                </Radio>
              ))}
          </Radio.Group>
        </Form.Item>
        <Form.Item
          label='退货原因'
          name='aftersaleReason'
          rules={[{ required: true }]}>
          <Select placeholder='退货原因' style={{ width: 120 }} allowClear>
            {reasonList &&
              reasonList.map((item, index) => (
                <Select.Option key={item.code + index} value={item.name}>
                  {item.name}
                </Select.Option>
              ))}
          </Select>
        </Form.Item>
        <Form.Item label='备注' name='remark'>
          <TextArea
            rows={4}
            maxLength={50}
            style={{ width: '50%' }}
            placeholder='请输入备注（最多50个字）'
          />
        </Form.Item>
      </Form>
      <a>注意：请确保商品退货事宜，点击确认按钮，退货商品将自动退款</a>
    </Modal>
  )
}
export default connect(state => ({
  orderChan: state.order.orderChan,
  orderType: state.order.orderType,
  orderStatus: state.order.orderStatus
}))(PopupDetail)
